import clsx from "clsx";
import { FoldersPerCell } from "./FoldersPerCell";
import { FoldersPerColumn } from "./FoldersPerColumn";
import { FoldersPerRow } from "./FoldersPerRow";
import { COLUMN_TRACK } from "./constants";
import type { FolderSuggestionTableProps } from "./types";

export const FolderSuggestionTable = ({
  table,
  structure,
  planNameById,
}: FolderSuggestionTableProps) => {
  const isRowFolder = structure === "level";
  const isCellFolder = structure === "buildingAndLevel";

  const columnCount =
    table.columns.values.length + (table.rows.key === null ? 0 : 1);
  const gridTemplateColumns = `repeat(${columnCount}, ${COLUMN_TRACK})`;

  return (
    <div className="min-h-0 overflow-auto">
      {/* Rows are subgrids, so a row can be its own card and still line up with the header. */}
      <div
        className={clsx(
          "grid gap-x-3",
          isRowFolder && "gap-y-1.5",
          isCellFolder && "gap-y-2",
        )}
        style={{ gridTemplateColumns }}
      >
        {isRowFolder && (
          <FoldersPerRow table={table} planNameById={planNameById} />
        )}
        {isCellFolder && (
          <FoldersPerCell table={table} planNameById={planNameById} />
        )}
        {!isRowFolder && !isCellFolder && (
          <FoldersPerColumn table={table} planNameById={planNameById} />
        )}
      </div>
    </div>
  );
};
